import React, { useState } from "react";
import Asset from "./asset";
import styles from "./project-single.module.scss";
import theme from "../styles/theme.module.scss";

function Row(props) {
  const pT = props.row.noTopPadding ? "" : "pT4";
  const pB = props.row.noBottomPadding ? "" : "pB4";
  const template = props.row.splitTemplate;
  if (template == "one") {
    return (
      <div
        className={[
          styles.row,
          styles[props.type],
          styles[template],
          theme.gmcont,
          theme[pT],
          theme[pB],
        ].join(" ")}
        style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
      >
        <div className={`${styles.entry} ${theme.gmmain}`}>
          <Asset asset={props.row.assets[0]} maxWidth="800" />
        </div>
      </div>
    );
  }
  if (template == "one-left") {
    return (
      <div
        className={[
          styles.row,
          styles[props.type],
          styles[template],
          theme.gdcont,
          theme.gmcont,
          theme[pT],
          theme[pB],
        ].join(" ")}
        style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
      >
        <div className={`${styles.entry} ${theme.gds2} ${theme.gde4} ${theme.gmmain}`}>
          <Asset asset={props.row.assets[0]} maxWidth="800" />
        </div>
      </div>
    );
  }
  if (template == "two") {
    return (
      <div
        className={[
          styles.row,
          styles[props.type],
          styles[template],
          theme.gdcont,
          theme.gmcont,
          theme[pT],
          theme[pB],
        ].join(" ")}
        style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
      >
        <div className={`${styles.entry} ${theme.gds3} ${theme.gde5} ${theme.gmmain}`}>
          <Asset asset={props.row.assets[0]} maxWidth="800" />
        </div>
        <div className={`${styles.entry} ${theme.gds8} ${theme.gde10} ${theme.gmmain}`}>
          <Asset asset={props.row.assets[1]} maxWidth="800" />
        </div>
      </div>
    );
  }
  if (template == "three") {
    return (
      <div
        className={[
          styles.row,
          styles[props.type],
          styles[template],
          theme[pT],
          theme[pB],
          theme.gmcont,
        ].join(" ")}
        style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
      >
        {props.row.assets &&
          props.row.assets.map((node, index) => (
            <div key={index} className={`${styles.entry} ${theme.gmmain}`}>
              <Asset asset={node} maxWidth="800" />
            </div>
          ))}
      </div>
    );
  }
  if (template == "four") {
    return (
      <div
        className={[
          styles.row,
          styles[props.type],
          styles[template],
          theme.gdcont,
          theme.gmcont,
          theme[pT],
          theme[pB],
        ].join(" ")}
        style={{ backgroundColor: `${props.bgColor}`, color: `${props.textColor}` }}
      >
        <div
          className={`${styles.entry} ${theme.gds2} ${theme.gde4} ${theme.mB4} ${theme.gms1} ${theme.gme2}`}
        >
          <Asset asset={props.row.assets[0]} maxWidth="800" />
        </div>
        <div
          className={`${styles.entry} ${theme.gds5} ${theme.gde7} ${theme.mB4} ${theme.gms3} ${theme.gme4}`}
        >
          <Asset asset={props.row.assets[1]} maxWidth="800" />
        </div>
        <div className={`${styles.entry} ${theme.gds6} ${theme.gde8} ${theme.gms1} ${theme.gme2}`}>
          <Asset asset={props.row.assets[2]} maxWidth="800" />
        </div>
        <div className={`${styles.entry} ${theme.gds9} ${theme.gde11} ${theme.gms3} ${theme.gme4}`}>
          <Asset asset={props.row.assets[3]} maxWidth="800" />
        </div>
      </div>
    );
  }
}

export default Row;
